var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("base-snackbar", { attrs: { errors: _vm.customerGetErrors } }),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { lg: "3", cols: "12" } },
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("v-autocomplete", {
                        attrs: {
                          label: "Company",
                          items: _vm.customerList,
                          "item-value": "id",
                          "item-text": "company",
                          loading: _vm.customerGetting
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "item",
                            fn: function({ item }) {
                              return [
                                _c(
                                  "span",
                                  { staticClass: "mr-2 primary--text" },
                                  [_vm._v(_vm._s(item.id))]
                                ),
                                _c(
                                  "small",
                                  {
                                    staticClass:
                                      "blue-grey--text text--darken-1"
                                  },
                                  [_vm._v(_vm._s(item.company))]
                                )
                              ]
                            }
                          }
                        ]),
                        model: {
                          value: _vm.customerId,
                          callback: function($$v) {
                            _vm.customerId = $$v
                          },
                          expression: "customerId"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Contact Name" },
                        model: {
                          value: _vm.contactName,
                          callback: function($$v) {
                            _vm.contactName = $$v
                          },
                          expression: "contactName"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Phone #" },
                        model: {
                          value: _vm.contactNumber,
                          callback: function($$v) {
                            _vm.contactNumber = $$v
                          },
                          expression: "contactNumber"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Email Address" },
                        model: {
                          value: _vm.email,
                          callback: function($$v) {
                            _vm.email = $$v
                          },
                          expression: "email"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "green",
                            dark: "",
                            dense: "",
                            block: "",
                            loading: _vm.billingPosting
                          },
                          on: { click: _vm.store }
                        },
                        [_c("span", [_vm._v("Save")])]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { lg: "9", cols: "12" } },
            [
              _c("v-data-table", {
                attrs: {
                  loading: _vm.orderGetting,
                  headers: _vm.headers,
                  items: _vm.details,
                  dense: "",
                  "hide-default-footer": ""
                },
                scopedSlots: _vm._u([
                  {
                    key: "item",
                    fn: function({ item, index, expand, isExpanded }) {
                      return [
                        _c("tr", [
                          _c("td", [_vm._v(_vm._s(index + 1))]),
                          _c("td", { staticClass: "text-center" }, [
                            _vm._v(_vm._s(_vm.drFormat(item.invoiceId)))
                          ]),
                          _c("td", [_vm._v(_vm._s(item.date.dateFormat()))]),
                          _c("td", { staticClass: "text-right" }, [
                            _vm._v(
                              _vm._s(
                                item.amount ? item.amount.phpFormat() : null
                              )
                            )
                          ]),
                          _c("td", [_vm._v(_vm._s(item.status))]),
                          _c(
                            "td",
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: { text: "", color: "red", small: "" },
                                  on: {
                                    click: function($event) {
                                      return _vm.removeItem(index)
                                    }
                                  }
                                },
                                [_c("v-icon", [_vm._v("mdi-delete")])],
                                1
                              ),
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    text: "",
                                    color: "blue-grey",
                                    small: ""
                                  },
                                  on: {
                                    click: function($event) {
                                      return expand(!isExpanded)
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "v-icon",
                                    { class: isExpanded ? "is-expanded" : "" },
                                    [_vm._v("mdi-chevron-down")]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ])
                      ]
                    }
                  },
                  {
                    key: "expanded-item",
                    fn: function({ item }) {
                      return [
                        _c("tr", [
                          _c(
                            "td",
                            { attrs: { colspan: "5" } },
                            [
                              _c("v-simple-table", {
                                attrs: { dense: "" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function() {
                                        return [
                                          _c("thead", [
                                            _c("tr", [
                                              _c("th", [_vm._v("Amount Paid")]),
                                              _c("th", [
                                                _vm._v("Actual Amount")
                                              ]),
                                              _c("th", [_vm._v("Particulars")])
                                            ])
                                          ]),
                                          _c("tbody", [
                                            _c("tr", [
                                              _c("td", [
                                                _vm._v(
                                                  _vm._s(
                                                    item.paidAmount
                                                      ? item.paidAmount.phpFormat()
                                                      : null
                                                  )
                                                )
                                              ]),
                                              _c("td", [
                                                _vm._v(
                                                  _vm._s(
                                                    item.actualAmount
                                                      ? item.actualAmount.phpFormat()
                                                      : null
                                                  )
                                                )
                                              ]),
                                              _c("td", [
                                                _vm._v(_vm._s(item.particulars))
                                              ])
                                            ])
                                          ])
                                        ]
                                      },
                                      proxy: true
                                    }
                                  ],
                                  null,
                                  true
                                )
                              })
                            ],
                            1
                          )
                        ])
                      ]
                    }
                  },
                  {
                    key: "body.append",
                    fn: function() {
                      return [
                        _c("tr", [
                          _c("th", { attrs: { colspan: "3" } }, [
                            _vm._v("Total")
                          ]),
                          _c("td", { staticClass: "text-right" }, [
                            _vm._v(_vm._s(_vm.totalAmount.phpFormat()))
                          ]),
                          _c("td", [_vm._v(" ")])
                        ]),
                        _c("tr", [
                          _c(
                            "td",
                            { attrs: { colspan: "2" } },
                            [
                              _c("v-autocomplete", {
                                attrs: {
                                  label: "Invoice No",
                                  items: _vm.billingStatementUnselected,
                                  "item-value": "id",
                                  "item-text": "invoiceId",
                                  "return-object": ""
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "selection",
                                    fn: function({ item }) {
                                      return [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(_vm.drFormat(item.invoiceId))
                                          )
                                        ])
                                      ]
                                    }
                                  },
                                  {
                                    key: "item",
                                    fn: function({ item }) {
                                      return [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "mr-2 blue-grey--text text--darken-2"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.drFormat(item.invoiceId)
                                              )
                                            )
                                          ]
                                        ),
                                        _c(
                                          "small",
                                          {
                                            staticClass:
                                              "blue-grey--text text--darken-2"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(item.amount.phpFormat())
                                            )
                                          ]
                                        )
                                      ]
                                    }
                                  }
                                ]),
                                model: {
                                  value: _vm.itemSelected,
                                  callback: function($$v) {
                                    _vm.itemSelected = $$v
                                  },
                                  expression: "itemSelected"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "td",
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Date",
                                  value: _vm.date,
                                  readonly: "",
                                  type: "date"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "td",
                            [
                              _c("v-text-field", {
                                attrs: { label: "Particulars" },
                                model: {
                                  value: _vm.particulars,
                                  callback: function($$v) {
                                    _vm.particulars = $$v
                                  },
                                  expression: "particulars"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "td",
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Amount",
                                  readonly: "",
                                  value: _vm.amount
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "td",
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    text: "",
                                    color: "green",
                                    small: ""
                                  },
                                  on: { click: _vm.addToBillingStatement }
                                },
                                [_c("v-icon", [_vm._v("mdi-plus")])],
                                1
                              )
                            ],
                            1
                          )
                        ])
                      ]
                    },
                    proxy: true
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }